//notification actions
import {
  GET_NOTIFICATION_OPEN_LIST,
  GET_NOTIFICATION_OPEN_LIST_SUCCESS,
  GET_NOTIFICATION_OPEN_LIST_ERROR,
  SYSTEM_NOTIFICATION_INTERNAL_SEND,
  SYSTEM_NOTIFICATION_INTERNAL_SEND_SUCCESS,
  SYSTEM_NOTIFICATION_INTERNAL_SEND_ERROR,
} from "./actionType";

// get notification Open List
export const getNotificationOpenList = () => ({
  type: GET_NOTIFICATION_OPEN_LIST,
});

export const getNotificationOpenListSuccess = (payload) => ({
  type: GET_NOTIFICATION_OPEN_LIST_SUCCESS,
  payload,
});

export const getNotificationOpenListError = (payload) => ({
  type: GET_NOTIFICATION_OPEN_LIST_ERROR,
  payload,
});

// system notification internal send
export const systemNotificationInternalSend = (payload) => ({
  type: SYSTEM_NOTIFICATION_INTERNAL_SEND,
  payload,
});
export const systemNotificationInternalSendSuccess = (payload) => ({
  type: SYSTEM_NOTIFICATION_INTERNAL_SEND_SUCCESS,
  payload,
});
export const systemNotificationInternalSendError = (payload) => ({
  type: SYSTEM_NOTIFICATION_INTERNAL_SEND_ERROR,
  payload,
});
